import { getFetch, postFetch, putFetch, deleteFetch } from 'utils/fetch';
import { LEGAL_DOCUMENT_ATTACHMENT_API } from 'api/config';

export function getList(query) {
  return getFetch(`${LEGAL_DOCUMENT_ATTACHMENT_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${LEGAL_DOCUMENT_ATTACHMENT_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${LEGAL_DOCUMENT_ATTACHMENT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${LEGAL_DOCUMENT_ATTACHMENT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${LEGAL_DOCUMENT_ATTACHMENT_API()}`, obj);
}



// WEBPACK FOOTER //
// ./src/api/legalDocumentAttachmentApi.js